import { RolePermissions } from '@/types/permissions';
import { User } from '@/api/queries/users';

export const ROLES = {
  NO_ACCESS: 'no_access',
  SUPER_ADMIN: 'super_admin',
  SITE_ADMIN: 'site_admin',
  MONITOR: 'monitor',
  RESEARCH_SUPPORT_SITE: 'research_support_site',
  RESEARCH_SUPPORT_RNI: 'research_support_rni',
  RESEARCHER_SITE: 'researcher_site',
  RESEARCHER_RNI: 'researcher_rni',
  CO_INVESTIGATOR_SITE: 'co_investigator_site',
  CO_INVESTIGATOR_RNI: 'co_investigator_rni',
  PRIMARY_INVESTIGATOR: 'primary_investigator',
} as const;
export type Role = (typeof ROLES)[keyof typeof ROLES];

export interface UserWithPermissions extends User {
  permissions: RolePermissions;
}
